import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { defaultSiteContent } from "../data/mock";
import { api } from "../lib/api";

const SiteContentContext = createContext(null);

export function SiteContentProvider({ children }) {
  const [siteContent, setSiteContent] = useState(defaultSiteContent);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/site-content");
      const remote = res?.data?.data || {};
      const hasAnyKeys = remote && Object.keys(remote).length > 0;
      setSiteContent(hasAnyKeys ? { ...defaultSiteContent, ...remote } : defaultSiteContent);
    } catch (err) {
      console.warn("Failed to load /site-content, using local defaults", err);
      setSiteContent(defaultSiteContent);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({
      siteContent,
      loading,
      refresh,
    }),
    [siteContent, loading, refresh]
  );

  return <SiteContentContext.Provider value={value}>{children}</SiteContentContext.Provider>;
}

export function useSiteContent() {
  const ctx = useContext(SiteContentContext);
  if (!ctx) throw new Error("useSiteContent must be used within SiteContentProvider");
  return ctx;
}
